export const BASEAPIURL =
  process.env.REACT_APP_API_URL || "http://localhost:39001/";
